module.exports = __webpack_public_path__ + "static/media/trappedWomen.a4293c8a.png";